import clsx from 'clsx';
import type { HTMLAttributes, PropsWithChildren, Ref } from 'react';

import * as styles from './style.css';
export type DividerOrientation = 'horizontal' | 'vertical';
export type DividerProps = PropsWithChildren &
  Omit<HTMLAttributes<HTMLDivElement>, 'type'> & {
    orientation?: DividerOrientation;
    size?: 'thinner' | 'default';
    dividerColor?: string;
  };

export const Divider = ({
  ref,
  orientation = 'horizontal',
  size = 'default',
  dividerColor = 'var(--affine-border-color)',
  style,
  className,
  ...otherProps
}: DividerProps & { ref?: Ref<HTMLDivElement> }) => {
  return (
    <div
      data-divider
      ref={ref}
      className={clsx(
        styles.divider,
        {
          [styles.verticalDivider]: orientation === 'vertical',
          [styles.thinner]: size === 'thinner',
        },
        className
      )}
      style={{
        backgroundColor: dividerColor ? dividerColor : undefined,
        ...style,
      }}
      {...otherProps}
    />
  );
};

export default Divider;
